import usePresentSelector from './usePresentSelector';
import React, { useContext } from 'react';
import RowSpacingComponent from './RowSpacingComponent';
import G from './Getters';
import { useMemo, useRef } from 'react';
import GridCell from './GridCell';
import { useStore } from 'react-redux';
import RowAdder from './RowAdder';
import CropDropRow from './CropDropRow';
import SpacerRowForRotatedText from './SpacerRow';
import { SCREENSHOT_IGNORE } from './UIConstants';
import DragRowButton from './DragRowButton';
import RowMoveDropRow from './RowMoveDropRow';
import { RowDragDispatch, RowDragState } from './RowDragProvider';
import TranslatableGridRow from './TranslatableGridRow';

import computeCellTextBounds, {getRotationSpacings} from './PositionEngine';
const getCellWidth = (cellX,cellW,referenceWidths) => {
  let widthsToSum = referenceWidths.slice(cellX, cellX + cellW);
  let sum = widthsToSum.reduce((a,b) => a+b,0)

  return sum;// + accountForMarginsAndBorders;
}

const placeholderStyle = () => ({
  color:'grey',
  fontSize:9,
  fontStyle:'italic',
})





export default React.memo(function ManualAnnotationRow ({
  editableTableRef,
  editable,

  rowSpacing,

  figurePanelId,

  row, 
  rowIndex, 
  cellDragEntered, 
  setCellDragEntered, 
  setDontUnselectCells,
  tableOutlineShowing, 
  widths, 


  editorStyle, 
  //getCellWidth, 
  currentWidths, 
  numRows,
}){

  const store = useStore();
  const state = store.getState();

  let colSpan = row.reduce((sum,cell) => sum + cell.w, 0) + 1;

  if( !figurePanelId ){
    throw Error("figurePanelId cannot be undefined.");
  }

  let doCellsSpanMultipleRows = usePresentSelector(state => {
    if(G.getTableDimensions(state,figurePanelId)[0] <= rowIndex ){
      return null;
    }else{
      return G.doCellsSpanMultipleRows(state,{figurePanelId,rowIndex}) 
    }
  })


  let allTextBounds = row.map(computeCellTextBounds);
  let cellsThatSpanThisRowOnly = allTextBounds.filter((_,ii) => !doCellsSpanMultipleRows[ii]);
  let cellDataThatSpanThisRowOnly = row.filter((_,ii) => !doCellsSpanMultipleRows[ii]);

  let angles = row.map( cell => {
    let direction = ({'down':1,'up':-1})[cell.data.style?.angleDirection] || -1;
    let angleMagnitude = cell.data.style?.angle || 0;

    let signedAngle = direction * angleMagnitude;

    return signedAngle;
  })

  let anglesOfCellsThatSpanThisRowOnly = angles.filter((_,ii) => !doCellsSpanMultipleRows[ii]);


  
  let rowDimensions = G.getFigurePanelRowPixelDimensions(state,{figurePanelId,row:rowIndex});

  let { upSpacing, downSpacing } = getRotationSpacings(
    cellsThatSpanThisRowOnly, 
    anglesOfCellsThatSpanThisRowOnly, 
    rowIndex,
    cellDataThatSpanThisRowOnly,
    rowDimensions,

  )

  const rowRef = useRef();
  const isLastRow = rowIndex === numRows-1;



  const rowDragState = useContext(RowDragState);
  const rowDragDispatch = useContext(RowDragDispatch);

  const dragRowMargin = 10;

  const inPreDragRowState = rowDragState && rowDragState.preDrag && rowDragState.hovering === rowIndex;

  const inDragRowState = rowDragState && rowDragState.dragging !== undefined;

  const draggingThisRow = rowDragState && rowDragState.dragging === rowIndex;


  let rowWidth = widths.reduce((a,b) => a+b);

  let dragRowLeftShift = -40;
  let totalDragRowWidth = rowWidth + 100;


  let dragEntryPositions = rowDragState?.dragging !== undefined && (<>
    <div 
      onMouseEnter={() => {

        //;

        if( inDragRowState ){
          rowDragDispatch({
            spaceAt:rowIndex
          })
        }
        /*
        rowDragDispatch({
          spaceAt:rowIndex
        })*/
      }}
      style={{
        position:'absolute',
        top:0,
        left:dragRowLeftShift,
        width:totalDragRowWidth,
        height:'50%',

        //background:'green',

        //background:'white',
        //opacity:0.7,
        zIndex:2000,

      }}>
    </div>
    <div onMouseEnter={() => {

      if( inDragRowState ){
        rowDragDispatch({
          spaceAt:rowIndex+1
        })
      }

    }}
      style={{

        position:'absolute',
        top:'50%',
        left:-40,
        width:rowWidth + 100,
        height:'50%',

        //background:'white',

        //opacity:0.7,
        zIndex:2000,

      }}/>

    {draggingThisRow && (

      <div 
        style={{
          pointerEvents:'none',

          position:'absolute',
          top:0,
          left:0,
          width:rowWidth+3,
          height:'100%',

          background:'white',

          opacity:0.7,
          zIndex:1000,

        }}/>
    )}
  </>)


  const cellComponents = useMemo(() => row.map( (cell,iiCell) => {
    let cellData = cell.data;
    let { style, value } = cellData;

    let displayPlaceholder = false;



    //let noStyle = Object.keys(style).length === 0 ;

    //let cellWidth = getCellWidth(cell.x,cell.w,currentWidths||widths)


    let computedStyle = {...style};

    if( computedStyle.borderTop && style.borderTop ){
      computedStyle.borderTop = style.borderTop
    }

    const cellLocationY = cell.y;
    const cellLocationX = cell.x;

    let key = cell.y+"-"+cell.x+"-"+cell.i;

    let pxWidth = getCellWidth(cell.x, cell.w, currentWidths||widths)


    return (


      <GridCell 
        editable={editable}
        figurePanelId={figurePanelId}

        cell={cell}
        computedStyle={computedStyle}
        currentWidths={currentWidths}
        widths={widths}
        tableOutlineShowing={tableOutlineShowing}
        key={key}
        textBounds={allTextBounds[iiCell]}
        //rotatedRectHeights={rotatedRectHeights[iiCell]}
        rowIndex={rowIndex}

        cellLocationY={cellLocationY}
        cellLocationX={cellLocationX}
        contents={cell.data} _id={cell.i} 
        pxWidth={pxWidth}
        cellDragEntered={cellDragEntered}
        setDontUnselectCells={setDontUnselectCells}
        setCellDragEntered={setCellDragEntered}

      /> 
    )
  }),[row]);

  return (
    <>

      {(false || (rowDragState?.dragging !== undefined && rowDragState?.spaceAt===rowIndex && rowDragState.dragging !== rowDragState.spaceAt)) && <RowMoveDropRow 
        {...{
          dragRowLeftShift,
          totalDragRowWidth
        }}
        figurePanelId={figurePanelId}
        rowDragDispatch={rowDragDispatch}
        fromIndex={rowDragState.dragging}
        toIndex={rowIndex}
        rowIndex={rowIndex}
        cellDragEntered={cellDragEntered}
        setCellDragEntered={setCellDragEntered}
      />}

      


      <SpacerRowForRotatedText height={upSpacing} />

        <TranslatableGridRow inDragRowState={inDragRowState} editable={editable} rowRef={rowRef}>
      
        {editable!==false && <td 
          style={{
            verticalAlign:'top',

            position:'sticky',
            background:'white',
            width:0,
            margin:0,
            padding:0,
            top:0,
            left:0,
            height:'100%',
            zIndex:20,


            /*
             There's a random space here,
             and I don't know why the space is there.
             */


          }}>

          <div style={{
            top:-5,
            left:-50,
            position:'absolute',
            width:50,
            
            height:(rowIndex === (numRows-1) ? 'calc(100% + 10px)' : '150%'), // this COVERS up the outline/grid content underneath so it doesn't look bad when scrolling horizontal
            background:'white',
            


          }}/>

          {dragEntryPositions}

          {((!inDragRowState || (rowDragState.dragging === rowIndex))) && <DragRowButton {...{
            dragRowMargin,
            rowDragDispatch,
            rowIndex,
            rowDragState,
            left:-40,
            tooltipPlacement:"left",
          }}/>}

          
        </td>}

        {cellComponents}

          {editable!==false && <td 
            class={""+SCREENSHOT_IGNORE}
            style={{
              verticalAlign:'top',
            }}>

            {(!inDragRowState || (rowDragState.dragging === rowIndex)) && <DragRowButton {...{
              inDragRowState,
              dragRowMargin,
              rowDragDispatch,
              rowIndex,
              rowDragState,
              right:10,
              tooltipPlacement:"right",
            }}/>}


            {false && rowIndex > 0 && <div style={{
              pointerEvents:(inDragRowState?'none':'unset'),
              position:'relative'}}>
              <RowAdder 
                {...{tooltip:'Add Row Here',tooltipPlacement:'right',
                  alwaysVisible:tableOutlineShowing,

                  pointerEvents:(inDragRowState?'none':'unset'),

                }}
                level={"top"}
                side={'right'} rowIndex={rowIndex} figurePanelId={figurePanelId}/>
            </div>}
          </td>}


      </TranslatableGridRow>

      <SpacerRowForRotatedText height={downSpacing} position={"bottom"} rowIndex={rowIndex}/>

      <RowSpacingComponent {...{
        colSpan, rowSpacing,
        editable,
      }}/>


      {true && (
        <>

          <CropDropRow 
            rowSpacing={rowSpacing}
            figurePanelId={figurePanelId}
            rowIndex={rowIndex}/>

        </>
      )}

      {isLastRow && (rowDragState?.dragging !== undefined && rowDragState?.spaceAt===numRows && rowDragState?.dragging !== rowIndex) && <RowMoveDropRow 
        {...{
          dragRowLeftShift,
          totalDragRowWidth
        }}
        figurePanelId={figurePanelId}
        rowDragDispatch={rowDragDispatch}
        fromIndex={rowDragState.dragging}
        toIndex={numRows}
        rowIndex={rowIndex}
        cellDragEntered={cellDragEntered}
        setCellDragEntered={setCellDragEntered}
      />}
    </>
  )

})
